export const calcPrismicRepo = (env: string, brand: string) => {
  const isLocalOrDev = env === 'test' || env.startsWith('localhost');
  return `sunrise-${brand}${isLocalOrDev ? '-test' : ''}`;
};
